import { CURRENT_CURRENCY_SYMBOL } from "@/Constants";
import { CREDIT_ENGINE_ROUTE } from "@/Constants/routesConstant";
import { useStaffPermission } from "@/Hooks/useStaffPermission";
import { RootState } from "@/Redux/Reducers";
import { WalletIcon } from "@/Utils/SVGExports/WalletIcon";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { StoreCreditsProps } from "../../Types";

export function StoreCredits(props: StoreCreditsProps) {
  const { expanded } = props;
  const history = useHistory();

  const { userCredits } = useSelector((state: RootState) => ({
    userCredits: state.creditEngine.userCredits,
  }));
  const { canManageMarketing } = useStaffPermission();

  return canManageMarketing ? 
    <div
      className={classNames(
        "tw-mt-[32px] tw-flex tw-min-h-fit tw-cursor-pointer tw-items-center tw-gap-[16px] tw-overflow-hidden tw-rounded-md tw-border tw-border-solid tw-border-[#111C361F] tw-transition-all",
        expanded ? "tw-mx-[16px] tw-px-[14px] tw-py-[15px]" : "tw-mx-[12px] tw-border-none",
      )}
      onClick={() => history.push(CREDIT_ENGINE_ROUTE)}
    >
      <span className="tw-flex">
        <WalletIcon />
      </span>
      <div className="tw-flex tw-flex-col tw-flex-nowrap tw-gap-[4px] tw-text-nowrap tw-text-[12px]/[15px] tw-font-medium tw-text-[#111C3699]">
        DotPe credits
        <div className="tw-line-clamp-1 tw-text-[14px]/[17px] tw-font-bold tw-text-[#111C36CC]">
          {CURRENT_CURRENCY_SYMBOL}
          {userCredits.toLocaleString("en-IN")}
        </div>
      </div>
    </div>
   : null;
}
